export default __webpack_public_path__ + "static/media/LockIcon.0a771500.svg";